/**
 * @generated SignedSource<<f83a6437e70c9a241dc01b565fb7b26a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WorkspaceRoutineTemplateCreateButtonMutation$variables = {
  workspaceId: string;
};
export type WorkspaceRoutineTemplateCreateButtonMutation$data = {
  readonly workspace: {
    readonly createRoutine: {
      readonly id: string;
    } | null;
  };
};
export type WorkspaceRoutineTemplateCreateButtonMutation = {
  response: WorkspaceRoutineTemplateCreateButtonMutation$data;
  variables: WorkspaceRoutineTemplateCreateButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "workspaceId"
      }
    ],
    "concreteType": "WorkspaceMutation",
    "kind": "LinkedField",
    "name": "workspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "type",
            "value": "TEMPLATE"
          }
        ],
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "createRoutine",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": "createRoutine(type:\"TEMPLATE\")"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceRoutineTemplateCreateButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceRoutineTemplateCreateButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e16a1fb11d0016fbf6ffeeccaf2cec97",
    "id": null,
    "metadata": {},
    "name": "WorkspaceRoutineTemplateCreateButtonMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceRoutineTemplateCreateButtonMutation(\n  $workspaceId: ID!\n) {\n  workspace(id: $workspaceId) {\n    createRoutine(type: TEMPLATE) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fc580ae92c60de8890e869edc809568b";

export default node;
